import { render, staticRenderFns } from "./ListRequest.vue?vue&type=template&id=768b8394&"
import script from "./ListRequest.vue?vue&type=script&lang=js&"
export * from "./ListRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports